/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["appearance-text-input{display:block;margin-bottom:15px}appearance-text-input label{text-transform:capitalize}"];
export { styles as styles };
